/**
 * Returns the images for the current page.
 * @param {Array} images - Array of image objects
 * @param {number} page - Current page index
 * @param {number} imagesPerPage - Number of images per page
 * @returns {Array} Array of images for the current page
 */
export function getPagedImages(images, page, imagesPerPage) {
  return images.slice(
    page * imagesPerPage,
    page * imagesPerPage + imagesPerPage
  );
}

/**
 * Calculates the total number of pages.
 * @param {Array} images - Array of image objects
 * @param {number} imagesPerPage - Number of images per page
 * @returns {number} Total pages
 */
export function getTotalPages(images, imagesPerPage) {
  return Math.ceil(images.length / imagesPerPage);
}
